"use client";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import clsx from "clsx";
import { Checkbox as RadixCheckbox } from "radix-ui";
import { useId } from "react";
import s from "./Checkbox.module.css";
export const Checkbox = ({ className, label, id: propsId, disabled, orientation = "left", ...restProps }) => {
    const reactId = useId();
    const id = propsId ?? reactId;
    return (_jsxs("div", { "data-disabled": disabled ? "" : undefined, "data-has-label": label ? "" : undefined, "data-orientation": orientation, className: clsx(className, s.Container), children: [_jsx(RadixCheckbox.Root, { className: s.Checkbox, id: id, disabled: disabled, ...restProps, children: _jsx(RadixCheckbox.Indicator, { className: s.CheckMark }) }), label && (_jsx("label", { htmlFor: id, className: s.Label, onMouseDown: (event) => {
                    if (!event.defaultPrevented && event.detail > 1)
                        event.preventDefault();
                }, children: label }))] }));
};
//# sourceMappingURL=Checkbox.js.map